import { ValueGetterParams } from "ag-grid-community";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";

export const getBudgetDetailsHistoryVarianceValueGetter =
  (
    key: keyof Pick<
      ProcessedHistoryData,
      "budgetVarianceCostBased" | "budgetVariancePercentage"
    >,
  ) =>
  ({ data }: ValueGetterParams<ProcessedHistoryData>) =>
    typeof data?.[key] === "string"
      ? data?.[key]
      : +(data?.[key]?.toFixed(2) ?? 0);
